import axios, { AxiosResponse } from 'axios';
import { getDataUrl, reportErrorSentry } from 'src/bff';
import { CarlineWithOffers, Offer } from 'src/types';

export const getOfertas = async (): Promise<Offer[]> => {
	try {
		const dataUrl = getDataUrl();
		const requestUrl = `${dataUrl}/v2/getOfertas`;

		const response: AxiosResponse<{ carlines: CarlineWithOffers[] }> = await axios.get(requestUrl);
		if (response.data.carlines) {
			return response.data.carlines.reduce((acc, carline) => {
				if (carline.ofertas) {
					acc.push(...carline.ofertas);
				}
				return acc;
			}, [] as Offer[]);
		}
		return null;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const getOferta = async (id: number): Promise<Offer> => {
	const ofertas = await getOfertas();
	if (ofertas) {
		return ofertas.find((oferta) => oferta.id == id);
	}
	return null;
};

export const getCarlinesWithOfertas = async (): Promise<CarlineWithOffers[]> => {
	try {
		const dataUrl = getDataUrl();
		const requestUrl = `${dataUrl}/v2/getOfertas`;

		const response: AxiosResponse<{ carlines: CarlineWithOffers[] }> = await axios.get(requestUrl);
		return response.data.carlines;
	} catch (error) {
		reportErrorSentry(error);
		return null;
	}
};

export const getDatosEconomicos = (oferta: Offer) => {
	if (!oferta.datosEconomicos) return [];

	return oferta.datosEconomicos.sort((a, b) => b.prioridad - a.prioridad).slice(0, 2);
};

export const isOfertaV2 = (oferta: Offer): boolean => 'datosEconomicos' in oferta;
